/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */

export type IndicatorsByMemberListOrdering = typeof IndicatorsByMemberListOrdering[keyof typeof IndicatorsByMemberListOrdering];


export const IndicatorsByMemberListOrdering = {
  '-computedAt': '-computedAt',
  '-signalCount': '-signalCount',
  computedAt: 'computedAt',
  signalCount: 'signalCount',
} as const;
